<div
  class="department-search d-flex align-items-center justify-content-between"
>
  <div class="search-input d-flex">
    <span
      class="search-icon-container"
      [innerHTML]="searchIconSVG | safeHTML"
    ></span>
    <input
      [(ngModel)]="filterConfig.serviceName"
      (ngModelChange)="applyFilter.emit()"
      placeholder="{{ 'all-services.dept-name' | translate }}"
    />
    <div (click)="filterConfig.serviceName = ''; applyFilter.emit()" *ngIf="filterConfig.serviceName" class="close-search">
      <img src="https://media.umangapp.in/cdn/web/theme/icons/cross-icon-dark.svg" alt="" class="bright">
    </div>
  </div>
  <div class="state-filter">
    <mat-form-field appearance="fill">
      <mat-select
        matNativeControl
        class="state-filter__dropdown"
        required
        (openedChange)="onOpenedChange($event)"
        [(ngModel)]="filterConfig.state"
        (ngModelChange)="applyFilter.emit()"
        [panelClass]="'custom-panel-class'"
        [disabled]="filterConfig.category === '1000'"
      >
        <mat-option *ngFor="let state of states" [value]="state.stateId" [ngClass]="{'disabled-list':state?.isUpcoming}">
          <div class="lang-values-state">
            {{ state.stateName | translate }} <div class="upcoming" *ngIf="state?.isUpcoming"><span>Coming Soon</span></div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
